import common from './common';
import area from './area';
import postType from './postType';
import post from './post';
import resume from './resume';
import org from './org';
export default {
    common,
    org,
    area,
    postType,
    post,
    resume
};
